import { render, staticRenderFns } from "./barHeader.vue?vue&type=template&id=5f5e5de5&"
import script from "./barHeader.vue?vue&type=script&lang=js&"
export * from "./barHeader.vue?vue&type=script&lang=js&"
import style0 from "./barHeader.vue?vue&type=style&index=0&id=5f5e5de5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports